import * as User from '../../constants/User/Credit'
import axios from 'axios';

import * as SG from '../../constants/AppSettings'
import { signInCheck, noticeAdd, loadEnd, loadStart, noticeRemove } from '../App';


export function noticeAddForCredit(msg, type='success') {
  return dispatch => {
    dispatch(noticeAdd(msg, type))
  }
}

export function noticeRemoveForCredit() {
  return dispatch => {
    dispatch(noticeRemove())
  }
}

export function createCreditCard(token) {
  return dispatch => {
    dispatch(loadStart())

    axios.post(SG.USER_CARD_REGIST_URL, token, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then((res) => {
      // dispatch(loadEnd())
      dispatch(createCreditCardResult(res.data))
      dispatch(signInCheck())
      dispatch(noticeAdd('カード情報を登録しました','success'))

      }).catch((res) => {
        dispatch(noticeAdd('登録失敗', 'error'))
        dispatch(loadEnd())
    })
    return {
      type: User.CARD_REGIST
    }
  }
}

export function createCreditCardResult(result) {
  return {
    type: User.CARD_REGIST_RESULT,
    result
  }
}

export function deleteCreditCard() {
  return dispatch => {
    dispatch(loadStart())
    dispatch(loadEnd())
    // axios.
  }
}

export function getCreditCardInfo() {
  return dispatch => {
    dispatch(loadStart())

    axios.get(SG.USER_CARDS_URL, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then((r) => {
      dispatch(loadEnd())
      dispatch(getCreditCardInfoResult(r.data.cards))
    }).catch((r) => {
      dispatch(loadEnd())
    })
  }
}

export function getCreditCardInfoResult(cards) {
  return {
    type: User.CARD_INFO_GET_RESULT,
    cards
  }
}


// WEBPACK FOOTER //
// ./src/actions/User/Credit.js